export enum ContractType {
  NotRequired = 0,
  AWB = 1,
  Security = 2,
  AWBSecurity = 3,
  Delivery = 4,
}
